import { Injectable } from '@angular/core';

import { environment } from '@environments/environment';

import { TealiumUtagService } from './utag.service';

@Injectable({
  providedIn: 'root'
})
export class ConfigService {
  configuration: any = {};

  constructor(private tealium: TealiumUtagService) {
    this.tealium.setConfig({
      account: environment.tealium_account,
      profile: environment.tealium_profile,
      environment: environment.tealium_environment
    });
  }

  // Initialy load
  loadConfig(): void {
    this.configuration = {
      consentConfig: {
        email: {
          required: false
        },
        consent: {
          required: false
        }
      }
    };
  }

  // Get config
  getConfig(): any {
    return this.configuration;
  }
}
